// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React, { useEffect } from 'react';
import { useBranding } from 'theme/SwitchableThemeProvider';

export const Snow = (): JSX.Element => {
  const { landingPageEffect } = useBranding();

  useEffect(() => {
    if (landingPageEffect !== 'snow') {
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://app.embed.im/snow.js';
    script.defer = false;
    document.body.appendChild(script);

    /// clean up on unmount
    return () => {
      const element = document.getElementById('embedim--snow');
      if (element) {
        element.remove();
      }
    };
  }, [landingPageEffect]);

  return <></>;
};
